/**
 * Shared bundle definitions — matches backend `brokers/registry.py`.
 *
 * A bundle is a preset selection of broker slugs. Used by:
 *   - RunQueryModal (drives per-query broker selection + discount)
 *   - Onboarding BrokerStep (drives default preferences)
 *
 * If backend bundles change, update this file so the UI stays in sync.
 */
import { Layers, MapPinned, Building2, ShieldCheck } from "lucide-react";

export const BUNDLES = [
  {
    key: "full_asset_sweep",
    label: "Full Asset Sweep",
    tagline: "The four brokers that surface assets fastest.",
    Icon: Layers,
    slugs: ["lexisnexis_accurint", "tloxp", "the_work_number", "docket_alarm"],
  },
  {
    key: "skip_trace",
    label: "Skip Trace Bundle",
    tagline: "Locate the debtor when contact info is stale.",
    Icon: MapPinned,
    slugs: ["lexisnexis_accurint", "tloxp", "pacer_courtapi"],
  },
  {
    key: "real_property_deep_dive",
    label: "Real Property Deep Dive",
    tagline: "Land, court judgments, prior civil history.",
    Icon: Building2,
    slugs: ["lexisnexis_accurint", "tloxp", "unicourt", "courtlistener"],
  },
  {
    key: "comprehensive_discovery",
    label: "Comprehensive Discovery",
    tagline: "Every broker — full portfolio scan.",
    Icon: ShieldCheck,
    slugs: [
      "lexisnexis_accurint",
      "tloxp",
      "the_work_number",
      "pacer_courtapi",
      "courtlistener",
      "docket_alarm",
      "unicourt",
    ],
  },
];

/**
 * Given a set of selected broker slugs, return the bundle key that exactly
 * matches, or null if the selection doesn't match any bundle.
 */
export const detectBundleFromSlugs = (selectedSlugs) => {
  const selected = new Set(selectedSlugs);
  for (const b of BUNDLES) {
    if (b.slugs.length !== selected.size) continue;
    if (b.slugs.every((s) => selected.has(s))) return b.key;
  }
  return null;
};

export const bundleBySlug = (key) => BUNDLES.find((b) => b.key === key) || null;
